<template>
  <div class="xiaohs-note m_media_card" :style="mediaStyle">
    <div
      v-if="subMsgComputed.content_type == 'note'"
      class="note-content m_media_clickable"
      @click="handleGoDetail(subMsgComputed.link)">
      <div class="m_media_preview">
        <img
          class="m_media_cover"
          :src="subMsgComputed.cover"
          @error="
            (e) => {
              e.target.src = defaultImage;
            }
          " />
      </div>
      <div class="m_media_text">
        {{ msgItem.msg }}
      </div>
    </div>

    <div
      v-else-if="subMsgComputed.content_type == 'common'"
      class="note-content m_media_clickable"
      @click="handleGoDetail(subMsgComputed.link)">
      <div class="m_media_preview">
        <img
          class="m_media_cover"
          :src="subMsgComputed.cover"
          @error="
            (e) => {
              e.target.src = defaultImage;
            }
          " />
      </div>
      <div class="m_media_text">
        {{ msgItem.msg }}
      </div>
    </div>

    <div v-else class="note-content">
      <div class="m_media_preview">
        <img
          class="m_media_cover"
          :src="subMsgComputed.image"
          @error="
            (e) => {
              e.target.src = defaultImage;
            }
          " />
      </div>
      <div class="m_media_text">
        {{ msgItem.msg }}
      </div>
    </div>
  </div>
</template>

<script>
import { toRefs, onMounted, reactive, computed, inject } from "vue";
import defaultImage from "@/assets/img/error_icon.jpg";

export default {
  components: {},
  setup() {
    const $tauriWindow = inject("tauriWindow");
    const msgItem = inject("msgItem");
    const data = reactive({});

    const subMsgComputed = computed(() => {
      try {
        return JSON.parse(msgItem?.submsg);
      } catch (e) {
        console.error(e);
        return {};
      }
    });

    const mediaStyle = {
      "--m-media-card-width": "200px",
      "--m-media-card-ratio": "3 / 4",
    };

    const handleGoDetail = (url) => {
      if (!url) {
        return;
      }
      $tauriWindow.openWindow(url);
    };

    onMounted(() => {});

    return {
      ...toRefs(data),
      msgItem,
      subMsgComputed,
      defaultImage,
      handleGoDetail,
      mediaStyle,
    };
  },
};
</script>

<style scoped>
.xiaohs-note {
  width: 200px;
}

.xiaohs-note .m_media_preview {
  aspect-ratio: 3 / 4;
}

.xiaohs-note .m_media_cover {
  object-fit: contain;
  background: #f5f7fa;
}

.xiaohs-note .m_media_text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>
